export function handleSiteModal(element, status) {
  if (status === "open") {
    if (element.nodeName === "DIALOG") {
      element.showModal();
    } else {
      element.hidden = false;
    }
  } else {
    if (element.nodeName === "DIALOG") {
      element.close();
    } else {
      element.hidden = true;
    }
  }
}

